import { CertifiedPreOwned } from '../components/inventory/certified-pre-owned.vue';
Vue.component('certified-pre-owned', CertifiedPreOwned);